jQuery(document).ready(function($) {
  if (!$('.hero-section').length) {
    return;
  }

  $(window).on('scroll', function() {
    if($(this).scrollTop() >= $('.hero-section').outerHeight() - 400) {
      $('.hero-section video').get(0).pause();
    } else {
      $('.hero-section video').get(0).play();
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/hero.js